import { render, staticRenderFns } from "./CrmPloyInfo.vue?vue&type=template&id=23e70d0e&"
import script from "./CrmPloyInfo.vue?vue&type=script&lang=js&"
export * from "./CrmPloyInfo.vue?vue&type=script&lang=js&"
import style0 from "./CrmPloyInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports